var lorem = {};
module['exports'] = lorem;
lorem.words = require("./words");


//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/hy/lorem/index.js
// module id = 3059
// module chunks = 1609